import clsx from "clsx";
import styles from "./C03_AnchorHeading.module.scss";

export interface AnchorHeadingProps {
  mainTitle: string;
  description: string;
  pageTitle: string;
  anchorKey: string;
}

export const AnchorHeading = (props: { content: AnchorHeadingProps }) => {
  const { content } = props;
  const { mainTitle, description, pageTitle, anchorKey } = content;
  const cleanAnchor = anchorKey?.replace(/\s+/g, "");

  const trimmedMainTitle = mainTitle?.trim();
  const trimmedDescription = description?.trim();
  const trimmedPageTitle = pageTitle?.trim();

  const showStandalonePageTitle =
    !trimmedMainTitle && !trimmedDescription && trimmedPageTitle;

  return (
    <div
      id={cleanAnchor}
      className={clsx("component", "wrapper", styles["subnav-header"])}
    >
      {showStandalonePageTitle ? (
        <h2>{pageTitle}</h2>
      ) : (
        <>
          {trimmedPageTitle && (
            <div className={styles["top-heading"]}>
              <h2>{pageTitle}</h2>
            </div>
          )}
          <div className={styles["title-with-intro"]}>
            <div className={styles["left-section"]}>
              {trimmedMainTitle &&
                (trimmedMainTitle && trimmedPageTitle ? (
                  <h3>{mainTitle}</h3>
                ) : (
                  <h2>{mainTitle}</h2>
                ))}
            </div>
            <div className={styles["right-section"]}>
              <p>{description}</p>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AnchorHeading;
